// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1444":"c2dd41b5","3689":"0f0c3f53"}[chunkId] + ".chunk.css";
};